import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../actions/IconButton.tsx';
import { TextField, type TextFieldProps } from './TextField.tsx';

export type PasswordFieldProps = Omit<TextFieldProps, 'type' | 'trailing'>;

/** Password input with a reveal toggle, so people can check what they typed on a phone keyboard. */
export const PasswordField = (props: PasswordFieldProps) => {
  const { t } = useTranslation();
  const [revealed, setRevealed] = useState(false);
  return (
    <TextField
      {...props}
      type={revealed ? 'text' : 'password'}
      trailing={
        <IconButton
          icon={revealed ? EyeOff : Eye}
          label={revealed ? t('ui.password.hide') : t('ui.password.show')}
          onClick={() => setRevealed((value) => !value)}
          size="sm"
        />
      }
    />
  );
};
